export default "__VITE_ASSET__Bi9zH7I8__"